import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	buttonClose: 'js-m-contact-teaser-popup__close',
	stateContactTeaserPopupShow: 'state-m-contact-teaser-popup--visible'
};

@createModule('ContactTeaserPopup')
/**
 * @author 
 */

export class ContactTeaserPopup extends TerrificSpec {
	$ctx: JQuery;
	$buttonClose: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$buttonClose = $(`.${classes.buttonClose}`, this.$ctx);

		this.$buttonClose.on('click', this.onCloseClick.bind(this));

		this.initContactTeaserPopup();

		resolve();
	}
	stop() {}

	_showContactTeaserPopup() {
		$(this._ctx).addClass(classes.stateContactTeaserPopupShow);
		$('html').addClass('no-scrolling--without-scrollbar');
	}

	_hideContactTeaserPopup() {
		$(this._ctx).removeClass(classes.stateContactTeaserPopupShow);
		$('html').removeClass('no-scrolling--without-scrollbar');
	}

	initContactTeaserPopup() {
		$(this._ctx).parent().find(".js-open-more-contacts").on('click', () => {
			this._showContactTeaserPopup();
		})
	}

	onCloseClick() {
		var me=this;
		me._hideContactTeaserPopup();
	}

}
